import type { CategoryTreeNode, ResolvedCategory } from '~/stores/category-tree'

/**
 * Product-details `categoryIds` are linked rows, not a guaranteed root→leaf
 * chain. Always walk descendants so a missing tree-root id still resolves.
 */
export function findDeepestMatching(
  nodes: CategoryTreeNode[],
  ancestors: CategoryTreeNode[],
  matches: (node: CategoryTreeNode) => boolean,
): ResolvedCategory | null {
  let best: ResolvedCategory | null = null

  for (const node of nodes) {
    if (matches(node)) {
      const current: ResolvedCategory = {
        node,
        ancestors: [...ancestors],
        children: node.children,
        depth: ancestors.length + 1,
      }
      if (!best || current.depth > best.depth) best = current
    }

    const childResult = findDeepestMatching(node.children, [...ancestors, node], matches)
    if (childResult && (!best || childResult.depth > best.depth)) {
      best = childResult
    }
  }

  return best
}
